import React from 'react';
import { Row } from 'react-bootstrap';

export function MenuDivider({ className = '' }) {
    return (
        <Row className={`d-none d-block d-md-none py-0 ${className} ml-1`}>
            <hr />
        </Row>
    );
}
